var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasLogo)?_c('img',{staticClass:"logo",class:{ 'is-clickable': _vm.advertisement.targetUrl },attrs:{"src":_vm.advertisement.logoUrl},on:{"click":function($event){$event.stopPropagation();return _vm.open.apply(null, arguments)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }